import { render, staticRenderFns } from "./MedicalReasonForm.vue?vue&type=template&id=652ac798&"
import script from "./MedicalReasonForm.vue?vue&type=script&lang=js&"
export * from "./MedicalReasonForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports